import { toast } from 'react-toastify';

let loaderCount = 0;
export function GetLocal(value) {
	return localStorage.getItem(value);
}

export function SetLocal(name, value) {
	localStorage.setItem(name, value);
}

export function ClearLocal() {
	localStorage.clear();
}

function StartAction() {
	loaderCount++;
	if (loaderCount == 1)
		document.body.classList.add("waitService");
}

function EndAction() {
	loaderCount--;
	if (loaderCount == 0)
		document.body.classList.remove("waitService");
}

export async function FetchService(serviceName, inputValue, callServiceSuccessMethod, callServiceErrorMethod, preCheck = null) {
	StartAction();
	console.clear();
	console.warn = console.error = () => { };
	if (preCheck) {
		const canContinue = await preCheck();

		if (!canContinue) {
			EndAction();
			return;
		}
	}
	var m = new Date();
	var cVersion = m.getUTCFullYear().toString() + (m.getUTCMonth() + 1).toString().padStart(2, "0") + m.getUTCDate().toString().padStart(2, "0") + m.getUTCHours().toString().padStart(2, "0") + m.getUTCMinutes().toString().padStart(2, "0");
	var configData = await fetch(window.location.origin + '/data/IranSystemSetting.json?v=' + cVersion).then(response => response.json());
	await FetchServiceNormal(serviceName, inputValue, callServiceSuccessMethod, callServiceErrorMethod, configData)
}


async function FetchServiceNormal(serviceName, inputValue, callServiceSuccessMethod, callServiceErrorMethod, configData) {
	var myHeaders = new Headers();
	myHeaders.append("Content-Type", "application/json");

	var raw = JSON.stringify(inputValue);

	var requestOptions = {
		method: 'POST',
		headers: myHeaders,
		body: raw,
		redirect: 'follow'
	};

	FetchServiceDone(configData.SERVER_URL + serviceName, requestOptions, serviceName, inputValue, callServiceSuccessMethod, callServiceErrorMethod, configData);

}



async function FetchServiceDone(fullServiceName, requestOptions, serviceName, inputValue, callServiceSuccessMethod, callServiceErrorMethod, configData) {
	fetch(fullServiceName, requestOptions)
		.then((response) => response.text())
		.then((result) => {
			try {
				if (configData.DebugMode == true)
					console.log({ 'serviceName': serviceName, 'inputValue': inputValue, 'result': result ? JSON.parse(result) : "" });
				return CallServiceDone(serviceName, result, callServiceSuccessMethod, callServiceErrorMethod);
			} catch (e) {
				console.log(e);
				toast.error("خطای داخلی");
			}
		})
		.catch(error => { toast.error('خطا در ارتباط با سرور'); EndAction() });
}

async function CallServiceDone(serviceName, serviceResult, callServiceSuccessMethod, callServiceErrorMethod, NeedsLogin) {
	//toast.dismiss();
	EndAction();
	var result = JSON.parse(serviceResult);
	if (!result?.Result?.IsSuccess) {

		if (callServiceErrorMethod == undefined)
			CallServiceError(result.Result?.Error?.resMessage, this);
		else
			callServiceErrorMethod(result.Result?.Error?.resMessage, this);
		if (NeedsLogin) {
			NeedsLogin()
		}
		if (result.Result?.Error?.resCode == 6 || result.Result?.Error?.info === "Session") {
			ClearLocal();
			window.location.href = "/";
		}
	}
	else {
		if (callServiceSuccessMethod == undefined)
			CallServiceSuccess(result?.Result?.Value, this);
		else
			callServiceSuccessMethod(result?.Result?.Value, this)
	}
}

async function CallServiceError(error) {
	toast.error(error);
}

async function CallServiceSuccess(success) {
	toast.success(success);
}

export function IsValidNationalCode(nationalCode) {
	if (IsEmptyString(nationalCode))
		return false;

	if (!IsValidPositiveNumber(nationalCode))
		return false;

	if (nationalCode.length === 10) {
		if (nationalCode === '1111111111' ||
			nationalCode === '0000000000' ||
			nationalCode === '2222222222' ||
			nationalCode === '3333333333' ||
			nationalCode === '4444444444' ||
			nationalCode === '5555555555' ||
			nationalCode === '6666666666' ||
			nationalCode === '7777777777' ||
			nationalCode === '8888888888' ||
			nationalCode === '9999999999') {
			return false;
		}
		let c = parseInt(nationalCode.charAt(9));
		let n = parseInt(nationalCode.charAt(0)) * 10 +
			parseInt(nationalCode.charAt(1)) * 9 +
			parseInt(nationalCode.charAt(2)) * 8 +
			parseInt(nationalCode.charAt(3)) * 7 +
			parseInt(nationalCode.charAt(4)) * 6 +
			parseInt(nationalCode.charAt(5)) * 5 +
			parseInt(nationalCode.charAt(6)) * 4 +
			parseInt(nationalCode.charAt(7)) * 3 +
			parseInt(nationalCode.charAt(8)) * 2;
		let r = n - parseInt(n / 11) * 11;
		if ((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r)) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
}

export function IsValidZipCode(value) {
	if (IsEmptyString(value))
		return false;

	if (!IsValidPositiveNumber(value))
		return false;

	return value.length === 10;
}

export function IsValidPassword(value, isRequired) {
	if (IsEmptyString(value)) {
		return !isRequired;
	}

	return value.length >= 8;

}

export function IsValidEmail(value) {
	let reg =
		/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

	return reg.test(value.toLowerCase());

}

export function IsValidPositiveNumber(value) {
	if (IsEmptyString(value))
		return false;
	let reg = /^\d+$/;

	return reg.test(value);
}

export function IsEmptyString(value) {
	return value == null || value.toString().trim() === "";
}

export function IsValidCellNumber(value) {
	if (IsEmptyString(value))
		return false;

	if (!IsValidPositiveNumber(value))
		return false;

	return value.length === 11 && value.startsWith("09");
}

export function ValidNationalCodeControl(value) {
	toast.dismiss();
	if (IsEmptyString(value) || !IsValidNationalCode(value)) {
		toast.error("کد ملی خود را وارد نمایید");
		return true;
	}
	return false;
}

export function IsEmptyInput(element) {
	toast.dismiss();
	if (element.current.classList.contains('rmdp-container')) {
		if (element.current.querySelector('input') && IsEmptyString(element.current.querySelector('input').value)) {
			element.current.querySelector('input').style.border = "1px solid #ff0000cc";
			return true;
		} else {
			element.current.querySelector('input') && (element.current.querySelector('input').style.border = "1px solid #ccc")
		}
	}
	else if (element.current.getAttribute('valid') == null) {
		if (IsEmptyString(element.current.value)) {
			element.current && (element.current.style.border = "1px solid #ff0000cc")
			//toast.error('مقدار ورودی های الزامی را پر نمایید');
			return true;
		} else {
			element.current && (element.current.style.border = "1px solid #ccc")
		}
	}
	if (element.current.getAttribute('valid') == 'comboBox') {
		if (element.current.value == 0) {
			element.current.style.border = "1px solid #ff0000cc";
			return true;
		} else {
			element.current.style.border = "1px solid #ccc"
		}
	}
	if (element.current.getAttribute('valid') == 'nationalCode') {
		if (IsEmptyString(element.current.value) || !IsValidNationalCode(element.current.value)) {
			element.current.style.border = "1px solid #ff0000cc";
			return true;
		} else {
			element.current.style.border = "1px solid #ccc"
		}
	}
	if (element.current.getAttribute('valid') == 'cellNumber') {
		if (IsEmptyString(element.current.value) || element.current.value.length != 11 && !element.current.value.startsWith("09")) {
			element.current.style.border = "1px solid #ff0000cc";
			return true;
		} else {
			element.current.style.border = "1px solid #ccc"
		}
	}
	return false;
}

export function Base64Type(value) {
	let val = "";
	switch (value.toLowerCase()) {
		case "png":
			val = "data:image/png;base64,";
			break;
		case "gif":
			val = "data:image/gif;base64,";
			break;
		case "jpg":
			val = "data:image/jpg;base64,";
			break;
		case "jpeg":
			val = "data:image/jpg;base64,";
			break;
		case "plain":
			val = "data:text/plain;base64,";
			break;
		case "html":
			val = "data:text/html;base64,";
			break;
		case "pdf":
			val = "data:application/pdf;base64,";
			break;
		case "tif":
			val = "data:application/tif;base64,";
			break;
		case "dwg":
			val = "data:application/octet-stream;base64,";
			break;
		case "kmz":
			val = "data:application/vnd.google-earth.kmz;base64,";
			break;
	}
	return val;
}

export function GetParamsUrl(value) {
	return new URL(window.location.href).searchParams.get(value);
}

export function ConvertCharacterDate(value) {
	if (value != undefined || value != null) {
		return value.replace(/۰/g, '0').replace(/۱/g, '1')
			.replace(/۲/g, '2')
			.replace(/۳/g, '3')
			.replace(/۴/g, '4')
			.replace(/۵/g, '5')
			.replace(/۶/g, '6')
			.replace(/۷/g, '7')
			.replace(/۸/g, '8')
			.replace(/۹/g, '9');
	} else {
		return "";
	}
}

export function ValidInput() {
	let value = false;
	document.querySelectorAll('input,textarea,select').forEach((item) => {
		if (item.hasAttribute('required') && (item.value == '' || item.value == 0)) {
			item.style.border = "1px solid #ff0000";
			value = true;
		} else
			item.style.border = "1px solid #ccc"
	});
	return value;
}